import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Page, PageTitleWithBack } from '../../../components';
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
// Icons
import { LocationCity, House, FormatListBulleted } from '@mui/icons-material';

const links = [
  {
    name: 'Neighborhood Start Templates',
    icon: <LocationCity fontSize="large" color="primary" />,
    url: '/admin/manage/start-templates/neighborhoods'
  },
  {
    name: 'Model Home Start Templates',
    icon: <House fontSize="large" color="primary" />,
    url: '/admin/manage/start-templates/model-homes'
  },
  {
    name: 'Plan Start Templates',
    icon: <FormatListBulleted fontSize="large" color="primary" />,
    url: '/admin/manage/start-templates/plans'
  }
];

export const ManageStartTemplates = () => {
  const classes = useStyles();
  return (
    <Page title="Manage Start Templates">
      <PageTitleWithBack backText="Back to Admin home" backUrl="/admin" title="Manage Start Templates" />
      <Grid spacing={2} container alignItems="center" className={classes.wrapper}>
        {links.map((link, i) => {
          return (
            <Fragment key={`${i}`}>
              <Grid xs={12} sm={6} md={4} item>
                <Link to={link.url} className={classes.link}>
                  <Card className={classes.cardRoot}>
                    <CardContent className={classes.content}>
                      {link.icon}
                      <Typography>{link.name}</Typography>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
    </Page>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    marginTop: '1rem'
  },
  link: {
    textDecoration: 'none'
  },
  cardRoot: {},
  content: {
    padding: 24,
    textAlign: 'center'
  },
  pageTitleWrapper: {
    '@media (min-width: 768px)': {
      flex: 1
    }
  },
  titleWrapper: {
    marginBottom: theme.spacing(0.5)
  }
}));
